import { Component, Input, Output, ViewChildren, EventEmitter } from '@angular/core';

@Component ({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent {
  constructor() {}
  @ViewChildren('overlayContainer') private overlayContainer: any;
  @Input() overlay = false;
  @Output() closeOverlay = new EventEmitter<void>();

  removeOverlay(clickEvent: any) {
    if (clickEvent.srcElement === this.overlayContainer.first.nativeElement) {
      this.closeOverlay.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-components/overlay/overlay.component.ts